<template>
  <div class="bg-white w-full p-4 sm:p-5">
    <div class="w-full overflow-x-auto">
      <table class="w-full text-sm">
        <thead class="sticky top-0 z-10">
          <tr class="border-b border-gray-200 bg-white">
            <th class="px-3 py-3 text-left font-semibold text-expressgray whitespace-nowrap bg-white">
              S/N
            </th>
            <th
              class="px-3 py-3 text-left font-semibold text-expressgray whitespace-nowrap cursor-pointer hover:text-express bg-white"
              v-for="(column, index) in columns"
              :key="index"
              @click="sortRecords(index)"
            >
              {{ column }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(val, i) in rows" :key="i" class="border-b border-gray-100 hover:bg-gray-50">
            <td class="px-3 py-3 whitespace-nowrap text-expressgray">{{ serialNumber(i) }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[0] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[1] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[2] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[3] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[4] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[5] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">{{ val[6] }}</td>
            <td class="px-3 py-3 whitespace-nowrap">
              <span
                class="px-2 py-1 rounded-full text-xs font-medium"
                :class="val[7] === 'Active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'"
              >{{ val[7] }}</span>
            </td>
            <td class="px-3 py-3 text-center">
              <button
                class="text-expressgray hover:text-express transition-colors"
                v-if="
                  account_type === 'junior_administrator' ||
                  account_type === 'super_administrator'
                "
                @click="edit_retailer(val[8])"
              >
                <i class="fas fa-edit"></i>
              </button>
            </td>
            <td class="px-3 py-3 text-center">
              <button
                class="text-expressgray hover:text-green-500 transition-colors"
                v-if="
                  account_type === 'junior_administrator' ||
                  account_type === 'super_administrator'
                "
                @click="
                  triggerRetailerWalletRecharge(val[5], val[8], val[3], val[2])
                "
              >
                <i class="fas fa-money-check-alt"></i>
              </button>
            </td>
            <td class="px-3 py-3 text-center">
              <label
                class="switch"
                v-if="
                  account_type === 'junior_administrator' ||
                  account_type === 'super_administrator'
                "
              >
                <input
                  type="checkbox"
                  :checked="val[7] === 'Active'"
                  @change="enable_disable(val[8], $event.target.checked)"
                />
                <span class="slider round"></span>
              </label>
            </td>
            <td class="px-3 py-3 text-center">
              <i
                class="fas fa-trash-alt text-expressgray hover:text-red-500 cursor-pointer transition-colors"
                @click="decommission_list_event(val[8], val[2], val[0])"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "RetailerListTable",
  props: {
    rowRaws: Array,
    account_type: String,
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  emits: ["decommission_list_event", "retailer_edit_event"],
  mounted() {
    this.rows = [...this.rowRaws];
  },
  components: {},
  data() {
    return {
      show_retailer_to_decommission: true,
      columns: [
        "Full-Name",
        "Email",
        "Mobile",
        "Business Name",
        "Address",
        "Country",
        "Wallet Balance",
        "Account Status",
        "Edit",
        "Recharge Wallet",
        "Enable/Disable Account",
        "Move Decommission List ",
      ],
      row: [],
      rows: [],
      sortIndex: null,
      sortDirection: null,
    };
  },
  watch: {
    rowRaws: function (newvalue) {
      this.rows = [...newvalue];
    },
  },
  methods: {
    serialNumber(rowIndex) {
      const page = Number.isFinite(this.currentPage) ? this.currentPage : 1;
      const size = Number.isFinite(this.perPage) ? this.perPage : 10;
      return (page - 1) * size + rowIndex + 1;
    },
    edit_retailer: function (user_id) {
      this.$emit("retailer_edit_event", { user_id: user_id });
    },
    decommission_list_event: function (retailer_id, mobile, name) {
      // console.log("decommission_list_event", retailer_id)
      this.$emit("decommission_list_event", {
        retailer_id: retailer_id,
        mobile: mobile,
        name: name,
      });
    },
    triggerRetailerWalletRecharge: function (
      country,
      user_id,
      business_name,
      mobile
    ) {
      this.$emit("rechargeRetailer", {
        country: country,
        user_id: user_id,
        business_name: business_name,
        mobile: mobile,
      });
    },
    enable_disable(user_id, status) {
      // console.log('enable_disable triggerred ' , `${JSON.stringify(userid)} - ${status}`)
      this.$store.dispatch("admins/action_enable_disable_retailer_account", {
        user_id: user_id,
        status: status,
        toast: this.$toast,
        router: this.$router,
      });
    },
    sortRecords: function (index) {
      if (this.sortDirection == null) {
        this.sortDirection = "asc";
      }
      this.sortIndex = index;
      this.rows = this.rows.sort((rowA, rowB) => {
        if (typeof rowA[index] == "number" || typeof rowB[index] == "number") {
          // console.log('number sortting')
          if (this.sortDirection === "asc" || this.sortDirection == null) {
            this.sortDirection = "desc";
            return rowA[index] - rowB[index];
          } else {
            this.sortDirection = "asc";
            return rowB[index] - rowA[index];
          }
          // return rowA[index].localeCompare(rowB[index], undefined, {'numeric': true})
        } else {
          return rowA[index].localeCompare(rowB[index]);
        }
      });
    },
  },
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
